/* eslint-disable prettier/prettier */
import { TranslationMap } from './default'

// eslint-disable-next-line @typescript-eslint/camelcase
export const zh_CN: TranslationMap = {
  "accountstatus.Active": "活跃",
  "accountstatus.Inactive": "不活跃",
  "accountstatus.Terminated": "终止",
  "additionalitems.title": "额外项目",
  "cart.addtocart": "添加到购物车",
  "cart.addtocart.alreadyincart": "@@产品@@已经在你的购物车里了",
  "cart.addtocart.currencylocked": "您的购物车目前被设置为@@CURRENCY@@。不可能在一个订单中合并多种货币。要购买这个产品，请先清除您的@@购物篮@@。",
  "cart.addtocart.locked": "您的购物车货币已被设置为@@CURRENCY@@，发货地点为@@LOCATION@@。",
  "cart.addtocart.shiptolocked": "您的购物车已经设置为运往地点\n\n@@LOCATION@@@\n\n要购买此产品，请先在您的@@购物篮@@中更改发货地点。",
  "cart.addtocart.success": "@@产品@@已被添加到您的购物车中",
  "cart.empty": "您的购物车目前是空的",
  "cart.empty.title": "您的购物车是空的",
  "cart.gotoproductlist": "转到产品列表",
  "cart.nolongervalid": "您的购物车是无效的，请更新它以继续。",
  "cart.recalculate": "重新计算",
  "cart.recalculate.rounding": "要求的金额被四舍五入以适应包装尺寸。",
  "cart.removefromcart.success": "@@产品@@已成功从您的购物车中删除",
  "cart.removeproduct": "您确定要从您的购物车中删除@@产品@@吗？",
  "cart.requestquote": "Request quote",
  "cart.updatecart": "更新",
  "cart.updatecart.success": "您的购物车中已更新@@产品@@。",
  "dangerousgoodsclass.1": "爆炸物 (1)",
  "dangerousgoodsclass.2.1": "易燃气体 (2.1)",
  "dangerousgoodsclass.2.2": "非易燃气体 (2.2)",
  "dangerousgoodsclass.2.3": "有毒气体 (2.3)",
  "dangerousgoodsclass.3": "易燃液体 (3)",
  "dangerousgoodsclass.4.1": "易燃固体 (4.1)",
  "dangerousgoodsclass.4.2": "易燃固体可燃物 (4.2)",
  "dangerousgoodsclass.4.3": "潮湿时有危险 (4.3)",
  "dangerousgoodsclass.5.1": "氧化作用 (5.1)",
  "dangerousgoodsclass.6.1": "有毒 (6.1)",
  "dangerousgoodsclass.6.2": "生物危害 (6.2)",
  "dangerousgoodsclass.7": "辐射性 (7)",
  "dangerousgoodsclass.8": "腐蚀性的 (8)",
  "dangerousgoodsclass.9": "杂项 (9)",
  "date.invalid": "The selected date is invalid",
  "datefilteroption.last3Months": "最近3个月",
  "datefilteroption.lastMonth": "上个月",
  "datefilteroption.lastWeek": "上周",
  "datefilteroption.lastYear": "去年的情况",
  "field.duplicatedphonenumber": "电话号码已经存在",
  "field.invalid": "@@VALUE@@是无效的",
  "field.invalidinternalemail": "电子邮件无效，必须由brenntag.com、brenntag-asia.com或digib.com提供。",
  "field.invalidphonenumber": "电话号码无效，使用格式61212345678",
  "field.required": "@@VALUE@@是必需的",
  "filter.accessStatus": "Access status",
  "filter.all": "都",
  "filter.allorders": "所有订单",
  "filter.allproducts": "所有产品",
  "filter.apply": "申请",
  "filter.brenntagOrderNumber": "Brenntag order number",
  "filter.compliancerequired": "要求遵守",
  "filter.createddate": "Creation date",
  "filter.customerName": "Customer name",
  "filter.customerNumber": "Customer number",
  "filter.customerpo.placeholder": "按客户PO号过滤",
  "filter.customerponumber": "Customer PO number",
  "filter.dangerousgoods": "Dangerous goods",
  "filter.deliveryNumber": "Delivery number",
  "filter.deliverydate": "Requested delivery date",
  "filter.enddate": "结束日期",
  "filter.filterby": "过滤方式",
  "filter.filters": "过滤器",
  "filter.from": "从",
  "filter.hazardous": "Hazardous goods",
  "filter.invoicenumber": "Invoice number",
  "filter.lastlogindate": "最后登录日期",
  "filter.myorders": "我的订单",
  "filter.myproducts": "我的产品",
  "filter.noresults": "没有发现结果",
  "filter.orderdate": "Order date",
  "filter.otherfilters": "其他过滤器",
  "filter.pill.accessStatus": "访问状态",
  "filter.pill.brenntagOrderNumber": "Brenntag订单号",
  "filter.pill.createdDate": "创建日期",
  "filter.pill.customerPONumber": "PO #",
  "filter.pill.dangerousGoods": "危险品",
  "filter.pill.deliveryDate": "Requested delivery date",
  "filter.pill.dueDate": "截止日期",
  "filter.pill.hazardousGoods": "危险品",
  "filter.pill.invoiceNumber": "发票号码",
  "filter.pill.issueDate": "发票日期",
  "filter.pill.lastLoginDate": "登录日期",
  "filter.pill.orderDate": "订购日期",
  "filter.pill.packageType": "Pack type",
  "filter.pill.pricePointExists": "Products with pricing",
  "filter.pill.productName": "Product name",
  "filter.pill.productNumber": "Product number",
  "filter.pill.quoteDate": "Quote date",
  "filter.pill.requestedDeliveryDate": "要求的交付",
  "filter.pill.resetAll": "重置所有过滤器",
  "filter.pill.role": "Role",
  "filter.pill.salesGroupId": "销售组织",
  "filter.pill.searchQuery": "搜索",
  "filter.pill.shipToLocationId": "Ship to",
  "filter.pill.status": "Status",
  "filter.pill.updatedDate": "更新日期",
  "filter.pill.userName": "User",
  "filter.placeholder.customerName": "按客户名称搜索",
  "filter.placeholder.customerNumber": "按客户编号搜索",
  "filter.placeholder.global": "搜索产品、订单或发票...",
  "filter.placeholder.userEmail": "通过电子邮件搜索",
  "filter.placeholder.username": "按名称搜索",
  "filter.pricePointExists": "有价格的产品",
  "filter.productName": "产品名称",
  "filter.quoteNumber": "Quote number",
  "filter.quotedate": "Quote date",
  "filter.role": "Role",
  "filter.salesRepName": "销售代表姓名",
  "filter.salesorganisation": "销售组织",
  "filter.search-salesorg.placeholder": "按客户或销售机构搜索",
  "filter.search.placeholder": "检索",
  "filter.shipto": "船到",
  "filter.startdate": "开始日期",
  "filter.status": "状况",
  "filter.until": "至",
  "filter.updated": "Updated",
  "filter.user": "User",
  "filter.userEmail": "电子邮件",
  "filter.userName": "名称",
  "footer.contactus": "联系我们",
  "footer.faqs": "常见问题",
  "footer.privacypolicy": "数据保护和隐私声明",
  "footer.termsofuse": "使用条款",
  "home.contact.1": "联系 Brenntag Connect 团队",
  "home.contact.2": "F.A.Q.",
  "home.heading.1": "你好，@@USERNAME@@",
  "home.heading.2": "欢迎来到布伦塔格公司网站!",
  "home.heading.3": "Brenntag Connect 是您的在线平台，便于您订购化学品和获取最新信息。",
  "home.heading.4": "快速行动",
  "home.invoices.list.1": "查看发票",
  "home.invoices.list.2": "下载分析证书",
  "home.label.explore": "探讨",
  "home.label.viewinvoices": "查看所有发票",
  "home.label.vieworders": "查看所有订单",
  "home.orders.list.1": "查看订单历史和状态",
  "home.orders.list.2": "下载分析证书",
  "home.products.list.1": "搜索布伦塔格目录",
  "home.products.list.2": "查看和下载SDS/TDS文件",
  "home.products.list.3": "订购产品",
  "home.profile.list.1": "导出发票数据",
  "home.profile.list.2": "出口订单数据",
  "home.profile.list.3": "重置密码",
  "home.recent.invoices.due": "最近到期的发票",
  "home.recent.invoices.issued": "最近开具的发票",
  "home.recent.orders.created": "最近创建的订单",
  "home.recent.orders.updated": "最近更新的订单",
  "invoice.customer": "Customer",
  "invoice.date": "Date issued",
  "invoice.dueDate": "发票到期日",
  "invoice.noinvoicesfound": "目前还没有发票。\n我们只有在完整的订单发货后才开具发票。",
  "invoice.number": "发票号码",
  "invoicestatus.Cancelled": "Cancelled",
  "invoicestatus.Open": "Open",
  "invoicestatus.Paid": "Paid",
  "invoicestatus.PaidOnline": "Paid online",
  "invoicestatus.ProcessingPayment": "Processing payment",
  "isolanguage.en": "English",
  "isolanguage.id": "Bahasa Indonesia",
  "isolanguage.ko": "한국어",
  "isolanguage.th": "ไทย",
  "isolanguage.vi": "Tiếng Việt",
  "isolanguage.zh-CN": "中文（簡體）",
  "isolanguage.zh-TW": "中文（繁體）",
  "label.Landline": "固定电话",
  "label.Mobile": "手机版",
  "label.additionalinformation": "其他信息",
  "label.addresses": "地址",
  "label.alternativesizes": "备选尺寸",
  "label.amountdue": "应付金额",
  "label.any": "任何",
  "label.anyquestions": "有什么问题吗？",
  "label.batchamount": "Batch amount",
  "label.batchnumber": "批次号",
  "label.batchsize": "批量大小",
  "label.billingaddress": "账单地址",
  "label.billtoaddress": "账单地址",
  "label.billtoaddresses": "账单地址",
  "label.billtoaddressincorrect": "要更改您的地址详细信息，请通过聊天与我们联系",
  "label.billtoaddressrequired": "需要提供账单地址",
  "label.brenntagordernumber": "布伦塔格的订单号",
  "label.browseproducts": "浏览产品",
  "label.browseusers": "浏览用户",
  "label.button.attach": "附件",
  "label.button.changesalesorg": "是的，改变销售组织",
  "label.button.editprofile": "编辑我的个人资料",
  "label.button.export": "出口",
  "label.button.nokeep": "不，保留",
  "label.button.update": "更新",
  "label.button.yesterminate": "是，终止",
  "label.by": "由",
  "label.callus": "打电话给我们",
  "label.cancel": "取消",
  "label.category": "种类",
  "label.changepassword": "重置密码",
  "label.changesalesorg": "改变销售组织结构",
  "label.changesalesorgwarning": "你确定你要改变销售组织吗？",
  "label.checkingavailability": "检查可用性...",
  "label.clickheretoreview": "点击这里查看我们的",
  "label.comments": "Comments",
  "label.company": "公司",
  "label.confirmeddeliveryamount": "确认的交付金额",
  "label.continueshopping": "继续购物",
  "label.country": "国家",
  "label.creationdate": "创建日期",
  "label.creditnote": "贷款说明",
  "label.customer": "客户",
  "label.customername": "客户名称",
  "label.customernumber": "客户编号",
  "label.customerponumber": "客户订单号",
  "label.customerporeference": "客户订单参考",
  "label.customerporeferencemaxlength": "客户订单参考不能超过@@LENGTH@@个字符",
  "label.customerporeferencerequired": "需要有客户的PO参考",
  "label.dangerousgoodsclass": "危险品等级",
  "label.dangerousgoodscode": "DG",
  "label.datedelivered": "交付日期",
  "label.datefrom": "日期从",
  "label.dateissued": "签发日期",
  "label.dateto": "日期至",
  "label.debitnote": "Debit note",
  "label.defaultlanguage": "Language",
  "label.delete": "删除",
  "label.deliverynumber": "送货编号",
  "label.details": "详细内容",
  "label.discountperpack": "每包折扣",
  "label.distributionchannel": "分销渠道",
  "label.division": "部门",
  "label.documents": "下载文件",
  "label.dontshowthis": "不要再展示这个了",
  "label.download.all": "下载全部",
  "label.download.pdf": "Download PDF",
  "label.editmode": "编辑模式",
  "label.email": "Email address",
  "label.emailaddress": "电子邮件地址",
  "label.exportdata": "出口数据",
  "label.exporting": "导出数据，可能需要一段时间...",
  "label.exportingerror": "输出文件时出错，请重试。",
  "label.exportinglonger": "仍在生成出口。它可能需要一些时间。",
  "label.exportingsuccess": "数据文件已成功导出。",
  "label.exportordersinvoicescsv": "直接将您的订单和发票的结构化数据导出为CSV或Excel（XLSX）文件。",
  "label.exportselectcategory": "选择一个类别和导出文件的日期范围。",
  "label.externaluserfile": "外部用户文件",
  "label.filesattached": "所附文件",
  "label.from": "来自。 ",
  "label.fullname": "Full name",
  "label.hazardousgoodscode": "HZ",
  "label.hazchem": "危害化学",
  "label.internaluserfile": "内部用户文件",
  "label.invoice": "Invoice",
  "label.invoice.status.Cancelled": "取消了",
  "label.invoice.status.Open": "Open",
  "label.invoice.status.Paid": "付费",
  "label.invoice.status.PaidOnline": "在线付费",
  "label.invoice.status.ProcessingPayment": "处理付款",
  "label.item": "项目",
  "label.items": "items",
  "label.language": "语种",
  "label.lastlogin": "最后一次登录",
  "label.learn_more_about_brenntag": "了解更多关于Brenntag Connect的信息",
  "label.logout": "登出",
  "label.minimumquantity": "最小数量",
  "label.myprofile": "My profile",
  "label.name": "全名",
  "label.next-step": "下一步",
  "label.no": "没有",
  "label.no-filesattached": "未附文件",
  "label.no-filesuploaded": "没有上传文件",
  "label.none": "没有",
  "label.nopriceavailable": "无价格可言",
  "label.notes": "Notes",
  "label.orderNumber": "订单号",
  "label.orderamount": "Order amount",
  "label.orderamount.zero": "订单金额不能为0，你可以在你的购物车中删除一个产品。",
  "label.orderdate": "订购日期",
  "label.orderdetails": "订购详情",
  "label.orderfiles": "订购文件",
  "label.orderlist": "订单列表",
  "label.ordervalue": "订单价值",
  "label.pack": "Pack",
  "label.packaging": "Packaging",
  "label.packaginginformation": "包装信息",
  "label.packinggroup": "包装组",
  "label.packsize": "包装尺寸",
  "label.packtype": "包装类型",
  "label.paymentreference": "付款参考",
  "label.paymentterms": "支付条款",
  "label.payonline": "Pay online",
  "label.personalinfo": "User information",
  "label.phonenumber": "电话",
  "label.placeorder": "下订单",
  "label.placingorder": "下订单",
  "label.preferences": "首选项",
  "label.previous-step": "前一个步骤",
  "label.price": "定价",
  "label.priceperpack": "每包价格",
  "label.pricesareexclusiveofsurcharges": "价格不包括附加费用或税收。",
  "label.pricesaresubjecttochange": "价格可能会有变化。",
  "label.productname": "产品名称",
  "label.productnumber": "产品编号",
  "label.products": "Products",
  "label.producttype": "产品类型",
  "label.profile": "形象",
  "label.purchaseOrderNumber": "客户订单号",
  "label.quantity": "数量",
  "label.quantity.minimumorderamount": "金额必须大于或等于@@MINIMORDERAMOUNT@@。",
  "label.quantity.minimumorderquantity": "数量必须大于或等于@@MINIMORDERQUANTITY@@。",
  "label.quantity.tiereddiscounts": "提供数量折扣",
  "label.quantity.toolarge": "数值太大",
  "label.quantity.zero": "值必须大于0",
  "label.quotedate": "引用日期",
  "label.quotenumber": "报价编号",
  "label.records": "项目",
  "label.redirecttoadmin": "转到管理界面",
  "label.remove": "移除",
  "label.removeproduct": "移除产品",
  "label.reorder": "重新排序",
  "label.reorderall": "重新排序所有",
  "label.requestcancellation": "要求取消",
  "label.requestedamount": "要求的金额",
  "label.requesteddeliverydate": "要求的交付日期",
  "label.requesteddeliverydate.tooltip": "请注意，我们不能总是保证您所要求的交货日期。交付时间取决于供货情况和我们布伦塔格团队的确认。",
  "label.requesteddeliverydate.warning": "视情况而定，并由Brenntag团队确认。",
  "label.requesteddeliverydaterequired": "要求的交付日期是必需的",
  "label.requestquote": "要求报价",
  "label.retry": "重试",
  "label.role": "角色",
  "label.role.Admin": "Admin",
  "label.role.CSR": "CSR",
  "label.role.ReadUser": "阅读用户",
  "label.role.SuperAdmin": "超级管理员",
  "label.role.User": "用户",
  "label.role.UserAdmin": "用户管理",
  "label.role.UserManager": "User Manager",
  "label.salesorganisation": "销售组织",
  "label.scheduleddeliverydate": "预定的交付日期",
  "label.selectpaymentmethod": "选择你的支付方式",
  "label.selectsalesorganisation": "选择销售组织",
  "label.shelflife": "保质期",
  "label.shippinginstructions": "Shipping instructions",
  "label.shipto": "运送到",
  "label.shiptoaddress": "送货地址",
  "label.shiptoaddresses": "送货地址",
  "label.shiptoaddressincorrect": "收货人选择很重要，因为它可以按交货地点显示正确的定价。如果您的收货地址不正确，请通过聊天与我们联系",
  "label.shiptoaddressrequired": "需要提供送货地址",
  "label.shoppingcart": "购物车",
  "label.size": "尺寸",
  "label.soldtoaddress": "售出地址",
  "label.sortby": "排序方式",
  "label.specifications": "规格",
  "label.statusacknowledged": "Acknowledged",
  "label.statusclosed": "Closed",
  "label.statusopen": "开放式",
  "label.storageconditions": "储存条件",
  "label.subtotal": "小计",
  "label.tab.attachedfiles": "附属文件",
  "label.tab.attachnew": "附上新的",
  "label.tax": "税收",
  "label.temperatureconditions": "温度条件",
  "label.termsandconditions": "Terms and conditions",
  "label.timezone": "时区",
  "label.total": "总数",
  "label.type": "类型",
  "label.unitprice": "单位价格",
  "label.unnumber": "联合国编号",
  "label.updated": "更新",
  "label.user": "用户",
  "label.validfrom": "Valid from",
  "label.validto": "Valid to",
  "label.viewquote": "查看报价",
  "label.viewvideos": "查看如何观看视频",
  "label.yes": "是的，是的",
  "label.yourproductnumber": "您的产品编号",
  "languageselection.modal.areyousure": "你确定你要改变你的语言吗？",
  "languageselection.modal.confirm": "是的，改变语言",
  "languageselection.modal.description": "改变您的语言将影响您的所有电子邮件和Brenntag Connect中的每个用户界面。",
  "languageselection.modal.title": "改变首选语言",
  "location.shipto.notavailable": "该产品在您选择的 \n运送地点。请选择其他地点。",
  "logout.changeswillbelost": "如果你注销，本页面上的更改将丢失。",
  "logout.confirmlogout": "你确定要继续吗？",
  "logout.itemsinyourshoppingcartcanbelost": "如果你退出，你的购物车里的物品可能会丢失。",
  "message.accessrestricted": "看来你没有访问权限来做你想做的事情。 \n如果这是不正确的，请联系你的管理员。",
  "message.admincsrredirect": "看来你有较高的访问权限，而且是在错误的地方!",
  "message.areyousure": "是否确定？",
  "message.changesalesorg": "更改销售组织将影响您的产品目录、订单清单、报价、发票以及Brenntag Connect中购物车中的所有当前项目。您可以在需要时将其改回。",
  "message.changeswillbelost": "本页上的变化将被丢失。",
  "message.documentnotfound": "由于重复或损坏的文件，已发现一个错误，或无法加载新的文件。",
  "message.noitemstoshow": "对不起，没有项目可供展示",
  "message.noprices": "通过聊天联系我们，要求提供该产品的价格",
  "message.pagenotfound": "这一页似乎不见了",
  "message.productnaforshipto": "请求报价时，发货地不可用。请选择另一个。",
  "order.cancelmodal.button": "Request order cancellation",
  "order.cancelmodal.question": "你确定要取消以下订单吗？",
  "order.cancelmodal.questionfollowup": "一旦你确认了取消请求，你将无法恢复该行动。",
  "order.cancelmodal.title": "要求取消订单",
  "order.cancelmodal.title.poabbr": "坡",
  "order.coadocument": "CoA文件",
  "order.confirmationdocument": "订单确认",
  "order.history.batch": "批量",
  "order.history.batch_amount": "批量金额",
  "order.history.bill_to": "账单到",
  "order.history.comment_from_user": "评论",
  "order.history.deliveryNumber": "送货编号",
  "order.history.delivery_date": "交付日期",
  "order.history.delivery_information": "交付信息",
  "order.history.hide": "隐藏",
  "order.history.missing_productname": "产品名称不可用。",
  "order.history.nologs": "这个订单没有日志。",
  "order.history.number": "数量",
  "order.history.orderDetails": "订购详情",
  "order.history.orderStatus": "订单状态",
  "order.history.order_amount": "订单金额",
  "order.history.payment_terms": "支付条款",
  "order.history.pricing_unit_value": "定价单位价值",
  "order.history.quantity_calculated": "计算的数量",
  "order.history.requested_delivery_date": "要求的交付日期",
  "order.history.ship_to": "运送到",
  "order.history.shipping_instructions": "运输说明",
  "order.history.show": "显示",
  "order.history.sold_to": "出售给",
  "order.history.status": "状况",
  "order.history.subtotal_value": "小计值",
  "order.history.title": "订单历史记录",
  "order.history.total_value": "总价值",
  "order.invoice.download": "发票下载",
  "order.invoice.title": "发票",
  "order.invoice.titlePlural": "Invoices",
  "order.invoice.view": "查看",
  "order.requestchange.allorderlinesdeleted": "您的订单必须至少有一个产品才能保持有效。要取消订单，请选择 \"请求取消 \"或通过聊天联系我们。",
  "order.requestchange.close": "关闭",
  "order.requestchange.closeeditmode": "关闭编辑模式",
  "order.requestchange.closeeditmodeconfirmation": "是的，关闭编辑模式",
  "order.requestchange.closewarning": "你确定要关闭该变更请求吗？",
  "order.requestchange.discardedwarning": "所有对这个订单进行的未保存的修改将被丢弃，不会被考虑。",
  "order.requestchange.leavewarning": "你确定你要离开这个页面吗？",
  "order.requestchange.placechangerequest": "放置更改请求",
  "order.requestchange.productnotavailable": "产品或价格不再适用的更改请求，请通过聊天联系我们。",
  "order.requestchange.requestchange": "要求更改",
  "order.requestchange.shiptoaddressnotavailable": "该订单的发货地址不可用，请选择其他发货地址或通过聊天联系我们。",
  "order.requestchange.shiptoaddressnotavailablewarning": "发货地址不可用",
  "order.status.Acknowledged": "认可",
  "order.status.Cancelled": "取消了",
  "order.status.Closed": "封闭",
  "order.status.Confirmed": "已确认",
  "order.status.Invoiced": "开具发票",
  "order.status.Open": "开放式",
  "order.status.OutForDelivery": "预定交付",
  "order.status.Submitted": "Submitted",
  "order.success.message": "您的订单现在正由布伦塔格团队进行审核。一旦审查完成，您将收到一份确认书，其中强调了交货的细节。\n\n如果您有任何疑问或想做任何修改\n请通过聊天联系Brenntag团队。",
  "order.success.title": "您的订单已经提交",
  "page.AccessRestricted": "限制进入",
  "page.CustomerList": "客户",
  "page.Home": "家",
  "page.InvoiceList": "发票",
  "page.NotFound": "找不到网页 (404)",
  "page.OrderList": "订单",
  "page.PaymentInvoice": "在线支付",
  "page.ProductList": "产品",
  "page.Profile": "我的简介",
  "page.QuoteList": "引语",
  "page.SearchResultsFor": "的搜索结果",
  "page.TermsAndConditions": "条款和条件",
  "page.TermsOfUse": "使用条款 - Brenntag Connect",
  "page.UserList": "用户",
  "paymentInvoice.error": "您的发票无法被检索到。请刷新页面并再次尝试。",
  "paymentInvoice.infoCard.credit": "信用",
  "paymentInvoice.infoCard.creditcardStoreInfo": "Brenntag公司不储存客户的任何信用卡信息。",
  "paymentInvoice.infoCard.debitNote": "借记卡",
  "paymentInvoice.infoCard.downloadpdf": "下载PDF",
  "paymentInvoice.infoCard.invoice": "发票",
  "paymentInvoice.infoCard.price": "价格",
  "paymentInvoice.infoCard.review": "点击审查我们的",
  "paymentInvoice.infoCard.terms": "条款和条件",
  "paymentRedirect.error.heading": "出了点问题",
  "paymentRedirect.error.subtitle": "请再试一次或通过聊天联系我们。",
  "paymentRedirect.error.title": "在支付过程中出现了错误，发票/借据没有被支付。",
  "paymentRedirect.invoiceList": "发票清单",
  "paymentRedirect.invoiceNumber": "发票号码",
  "paymentRedirect.paidAmount": "已付金额",
  "paymentRedirect.paymentReference": "付款参考",
  "paymentRedirect.pending.heading": "有待确认",
  "paymentRedirect.pending.subtitle": "一旦付款得到确认，将由布伦塔格团队进行处理，并相应地更新状态。",
  "paymentRedirect.pending.title": "您的付款正在等待支付机构的确认。",
  "paymentRedirect.refused.heading": "拒绝付款",
  "paymentRedirect.refused.subtitle": "请使用不同的付款方式再试。",
  "paymentRedirect.refused.title": "你的付款被拒绝，因此不成功",
  "paymentRedirect.success.heading": "谢谢你",
  "paymentRedirect.success.subtitle": "您的发票已被支付。布伦塔格团队将处理付款并更新发票状态。",
  "paymentRedirect.success.title": "你已经成功支付，你的请求正在处理中",
  "paymentterms.A001": "自投资日起120天，15日之前",
  "paymentterms.A002": "自投资日起15天，在25日之前",
  "paymentterms.A003": "从邀请日算起15天，到第5天",
  "paymentterms.A004": "自发票日期起30天内，在10日之前",
  "paymentterms.A005": "自发票日期起30天内，15日之前",
  "paymentterms.A006": "自发票日期起30天内，在20日之前",
  "paymentterms.A007": "自发票日期起30天内，在25日之前",
  "paymentterms.A008": "自发票日期起45天，在20日之前",
  "paymentterms.A009": "自发票日期起45天，在25日之前",
  "paymentterms.A010": "自发票日期起60天内，在10日之前",
  "paymentterms.A011": "自发票日期起60天内，15日之前",
  "paymentterms.A012": "自发票日期起60天，在20日之前",
  "paymentterms.A013": "自发票日期起60天内，在25日之前",
  "paymentterms.A014": "发票日期后75天，由eom",
  "paymentterms.A015": "自发票日期起90天内，在10日之前",
  "paymentterms.A016": "自发票日期起90天内，15日之前",
  "paymentterms.A017": "自发票日期起90天，在20日之前",
  "paymentterms.A018": "自发票日期起90天，在25日之前",
  "paymentterms.A019": "自发票日期起60天内，在26日之前",
  "paymentterms.A020": "自邀请日起45天内，10日之前",
  "paymentterms.A021": "0-10:20,11-20:EoM,&gt;=21 NxtM10",
  "paymentterms.A022": "投资26-10：支付14,11-25。支付28",
  "paymentterms.A023": "20日截稿，28日付款",
  "paymentterms.A024": "45d fr inv; pay 2nd/12th/22nd",
  "paymentterms.A025": "45天（截止到25日），15日之前",
  "paymentterms.A026": "发放日期起150天，第25天支付",
  "paymentterms.B004": "发票日期起4天",
  "paymentterms.B005": "发票日期起5天内",
  "paymentterms.B007": "发票日期起7天内",
  "paymentterms.B009": "发票日期起9天",
  "paymentterms.B010": "发票日期起10天内",
  "paymentterms.B013": "发票日期起13天",
  "paymentterms.B014": "自发票日期起14天",
  "paymentterms.B015": "自发票日期起15天内",
  "paymentterms.B018": "发票日期起18天内",
  "paymentterms.B020": "20天后的发票。日期",
  "paymentterms.B021": "自发票日期起21天",
  "paymentterms.B022": "发票日期起22天",
  "paymentterms.B028": "自发票日期起28天",
  "paymentterms.B029": "自发票日期起29天",
  "paymentterms.B030": "自发票日期起30天内",
  "paymentterms.B037": "自发票日期起37天",
  "paymentterms.B038": "自发票日期起38天",
  "paymentterms.B040": "自发票日期起40天内",
  "paymentterms.B045": "自发票日期起45天",
  "paymentterms.B050": "自发票日期起50天内",
  "paymentterms.B055": "自发票日期起55天",
  "paymentterms.B060": "自发票日期起60天内",
  "paymentterms.B065": "自发票日期起65天",
  "paymentterms.B068": "自发票日期起68天",
  "paymentterms.B070": "自发票日期起70天",
  "paymentterms.B075": "自发票日期起75天",
  "paymentterms.B080": "自发票日期起80天",
  "paymentterms.B085": "自投资之日起85天。日期",
  "paymentterms.B090": "自发票日期起90天内",
  "paymentterms.B105": "自发票日期起105天",
  "paymentterms.B120": "自发票日期起120天",
  "paymentterms.B150": "自发票日期起150天",
  "paymentterms.B180": "自发票日期起180天内",
  "paymentterms.B360": "自邀请日期起360天",
  "paymentterms.BA01": "预付50%，余款30天内支付",
  "paymentterms.BA02": "预付30%，余款30天内支付",
  "paymentterms.BA03": "60% ADV, 40% PDC UPON DEL 30D",
  "paymentterms.BA04": "30%的预付款和70%的预付款见票即付",
  "paymentterms.BA05": "30％的预付款和70％的预付款。",
  "paymentterms.BA06": "80%为预付款，20%为见票即付。",
  "paymentterms.BA07": "20% TT预付款 80% DP见票即付",
  "paymentterms.BA08": "28% tt adv 72% 60d fr inv date",
  "paymentterms.BA09": "70%的TT预付款30%的DP，见缝插针",
  "paymentterms.BA10": "50% TT 垫款 50% DP 见票即付",
  "paymentterms.BA11": "20％的TNT预付款 80％的TNT见票即付",
  "paymentterms.BA12": "40%预付款，60%提单日期",
  "paymentterms.BA13": "50%的预付款，50%的基本日期",
  "paymentterms.BA14": "预付50%，余款45天内支付",
  "paymentterms.BA15": "50％的预付款，45天后的日期",
  "paymentterms.BA16": "50%的预付款，50%的贷款，见票即付。",
  "paymentterms.BA17": "50% ADV, 50% At Sight B/L COPY",
  "paymentterms.BA18": "70%预付款，30%见票即付",
  "paymentterms.BA19": "20% TT预付款 80% COD",
  "paymentterms.BA20": "30%DP,70%在提单60天后",
  "paymentterms.BA21": "50％预付款，50％见票即付",
  "paymentterms.BA22": "50% 预付 50% 立即支付",
  "paymentterms.BA23": "70%见票即付，30%见票即付75天",
  "paymentterms.BA24": "50%预付款，50%见票即付",
  "paymentterms.BA25": "30％的预付款，70％的空白日期",
  "paymentterms.BA26": "10％的Dep agst pi，90％的TT@sight",
  "paymentterms.BA27": "10％的预付款，90％的预付款见票即付",
  "paymentterms.BA28": "15%的预付款，85%的预付款。",
  "paymentterms.BA29": "40%的预付款，巴尔的摩",
  "paymentterms.BA30": "30％的T型车预付款，70％的30天后的B/L",
  "paymentterms.BA31": "90%预付现金，10%90天内到账",
  "paymentterms.BA32": "50％的TT预付款，50％的TT 15D FR B/L",
  "paymentterms.BA33": "50％的特级初等教育，50％的30天后教育。",
  "paymentterms.BA34": "30天后，60%的预付款，40%的PDC。",
  "paymentterms.BA35": "50%预付款/50%自投资日起60天",
  "paymentterms.BADV": "预付账款",
  "paymentterms.BB05": "爆炸日期后的5天",
  "paymentterms.BB07": "7天后的爆炸日期",
  "paymentterms.BB10": "爆炸日期后的10天",
  "paymentterms.BB14": "自爆炸日期起14天",
  "paymentterms.BB15": "自爆炸日期起15天内",
  "paymentterms.BB20": "自爆炸日期起20天",
  "paymentterms.BB21": "自爆炸日期起21天",
  "paymentterms.BB30": "自爆炸日期起30天内",
  "paymentterms.BB35": "自爆炸日期起35天",
  "paymentterms.BB38": "自爆炸日期起38天",
  "paymentterms.BB40": "自爆炸日期起40天",
  "paymentterms.BB45": "自爆炸日期起45天",
  "paymentterms.BB46": "LC 自爆炸日期起45天",
  "paymentterms.BB50": "自爆炸日期起50天内",
  "paymentterms.BB60": "自爆炸日期起60天内",
  "paymentterms.BB65": "自爆炸日期起65天",
  "paymentterms.BB70": "自爆炸日期起70天",
  "paymentterms.BB75": "自爆炸日期起75天",
  "paymentterms.BB85": "自爆炸日期起85天",
  "paymentterms.BB90": "自爆炸日期起90天内",
  "paymentterms.BB97": "自爆炸日期起97天",
  "paymentterms.BB98": "自爆炸日期起98天",
  "paymentterms.BB99": "自爆炸日期起99天",
  "paymentterms.BCBD": "交付前的现金",
  "paymentterms.BCOD": "货到付款",
  "paymentterms.BD01": "d/a 从b/l日期起15天",
  "paymentterms.BD02": "D/A 自B/L日期起30天",
  "paymentterms.BD03": "D/A 自B/L日期起45天",
  "paymentterms.BD04": "D/A 自B/L日期起60天",
  "paymentterms.BD05": "D/A 自B/L日期起75天",
  "paymentterms.BD06": "D/A 自B/L日期起90天",
  "paymentterms.BD07": "D/A 自B/L日期起120天",
  "paymentterms.BD12": "文档接受120天",
  "paymentterms.BD15": "文档接受期为15天",
  "paymentterms.BD30": "文档接受期为30天",
  "paymentterms.BD45": "文档接受期为45天",
  "paymentterms.BD60": "文档接受60天",
  "paymentterms.BD75": "文档接受75天",
  "paymentterms.BD90": "文档接受90天",
  "paymentterms.BDAA": "接受的文件",
  "paymentterms.BDAP": "博士学位证书，一见钟情",
  "paymentterms.BE00": "发票日期后0天，20日之前",
  "paymentterms.BE14": "15天内，邀请dd，eom在20日之前完成。",
  "paymentterms.BE15": "15天内完成，并在20日之前完成。",
  "paymentterms.BE16": "15天EOM",
  "paymentterms.BE20": "20天后，邀请dd，eom在20日之前完成。",
  "paymentterms.BE21": "20 DAYS FR BL DD, EOM BY 20TH",
  "paymentterms.BE22": "20天后，在20日之前完成。",
  "paymentterms.BE23": "20天后，即25日",
  "paymentterms.BE30": "30天后，即20日之前",
  "paymentterms.BE31": "在25日之前完成",
  "paymentterms.BE32": "32天 月末第2天",
  "paymentterms.BE33": "60天月底前第2次",
  "paymentterms.BE45": "45天EOM",
  "paymentterms.BE60": "60天EOM",
  "paymentterms.BE61": "60天后，即20日之前",
  "paymentterms.BE62": "60天后，15日之前",
  "paymentterms.BE63": "60天 月底前 4日",
  "paymentterms.BE90": "90天EOM",
  "paymentterms.BE91": "90天后，第5天",
  "paymentterms.BIMM": "即时",
  "paymentterms.BL15": "lc 15天见效",
  "paymentterms.BL21": "lc 21天见效",
  "paymentterms.BL30": "lc 30天，见票即付",
  "paymentterms.BL45": "lc 45天，见票即付",
  "paymentterms.BL60": "lc 60天，见票即付",
  "paymentterms.BL61": "LC 60 DAYS BL",
  "paymentterms.BL75": "lc 75天见票即付",
  "paymentterms.BL90": "lc 90天，见票即付",
  "paymentterms.BL91": "LC 90 DAYS BL",
  "paymentterms.BLAS": "贷方付款，见票即付",
  "paymentterms.BP12": "120天前的文件",
  "paymentterms.BP30": "30天内未支付的文件",
  "paymentterms.BP60": "60天前的文件",
  "paymentterms.BPAA": "视觉上的D/P",
  "paymentterms.BTAS": "观察到的TT",
  "paymentterms.CAD1": "凭单据现金",
  "paymentterms.CBO1": "CBO",
  "paymentterms.CBO2": "30% Cbo, 70% Cbd",
  "paymentterms.CBO3": "50% Cbo, 50% Cbd",
  "paymentterms.CBO4": "50% CBO, 50% COD",
  "paymentterms.CBO5": "50%的CBO，50%的投资后30天",
  "paymentterms.CNMT": "cnmt--托运",
  "paymentterms.D001": "针对文件的tt",
  "paymentterms.D002": "提前告知",
  "paymentterms.D004": "tt eom 30d by 20th frm bl dd",
  "paymentterms.D005": "tt 发票日期后30天",
  "paymentterms.D006": "tt 自爆炸日期起45天",
  "paymentterms.D007": "tt 自投资日期起45天",
  "paymentterms.D008": "tt 发票日期后60天",
  "paymentterms.D010": "提单日期起65天",
  "paymentterms.D011": "tt 发票日期后25天",
  "paymentterms.D012": "TT AGAINST BL",
  "paymentterms.D013": "7天内货到付款，见票即付",
  "paymentterms.D014": "交付前的T/T",
  "paymentterms.D015": "在订单确认后，Tt",
  "paymentterms.D016": "tt 发票日期后2天",
  "paymentterms.D017": "tt 发票日期后90天",
  "paymentterms.DD01": "直接扣款30天",
  "paymentterms.DD02": "直接扣款60天",
  "paymentterms.DD03": "直接扣款90天",
  "paymentterms.E001": "10日之前的30天",
  "paymentterms.E002": "eom 30天 15日之前",
  "paymentterms.E003": "30天，20日",
  "paymentterms.E004": "25日前30天",
  "paymentterms.E005": "10日之前的60天",
  "paymentterms.E006": "15日之前的60天",
  "paymentterms.E007": "60天，20日",
  "paymentterms.E008": "25日之前的60天",
  "paymentterms.E009": "90天后的第10天",
  "paymentterms.E010": "15日之前的90天",
  "paymentterms.E011": "90天后的20日",
  "paymentterms.E012": "25日之前的90天",
  "paymentterms.E013": "EOM",
  "paymentterms.E014": "EOM 30天",
  "paymentterms.E015": "EOM 30天后5日",
  "paymentterms.E016": "EOM 30天后 10日",
  "paymentterms.E017": "EOM 30D BY 20",
  "paymentterms.E018": "EOM 30D BY 25",
  "paymentterms.E019": "EOM 30天 (截止日期为25日)",
  "paymentterms.E020": "EOM 30D (25日为截止日期)到5日",
  "paymentterms.E021": "EOM 30D (25日截止) 10日之前",
  "paymentterms.E022": "EOM 45天 (截止日期为25日)",
  "paymentterms.E023": "EOM 60天",
  "paymentterms.E024": "EOM 60天后的第五天",
  "paymentterms.E025": "EOM 60天后10日",
  "paymentterms.E026": "EOM 60天后15日",
  "paymentterms.E027": "EOM 60天 (截止日期为25日)",
  "paymentterms.E028": "EOM 60D (25日截止) 在5日之前完成",
  "paymentterms.E029": "EOM 60D (25日截止) 10日之前",
  "paymentterms.E030": "EOM 90天",
  "paymentterms.E031": "第7天之前的90天",
  "paymentterms.E032": "EOM 90天 (截止日期为20日)",
  "paymentterms.E033": "EOM 90天 (截止日期为25日)",
  "paymentterms.E034": "5日之前的EOM",
  "paymentterms.E035": "EOM BY 10TH",
  "paymentterms.E036": "EOM 30D (截止日期20日) 15日之前",
  "paymentterms.E037": "EOM 90D (截止日期25日)，7日之前",
  "paymentterms.E038": "45天（截止到25日），5天。",
  "paymentterms.E039": "EOM 60天 (截止日期为20日)",
  "paymentterms.E040": "90天（截止到25日），8天。",
  "paymentterms.E041": "EOM 60天（截止日期为25日） 15",
  "paymentterms.E042": "EOM 90天（截止日期为25日） 5日",
  "paymentterms.E043": "EOM 90天（截止日期为25日） 10",
  "paymentterms.E044": "EOM 90天（截止日期为25日）15",
  "paymentterms.E045": "EOM 90天（截止日期为25日）20日",
  "paymentterms.E046": "120天（截止日期为25日）15日",
  "paymentterms.E047": "EOM 30天（截止日期为25日）15日",
  "paymentterms.E048": "下月同日到期",
  "paymentterms.E049": "30天（27日到期）。",
  "paymentterms.E050": "60天到期的EOM 25日",
  "paymentterms.E051": "EOM 210D",
  "paymentterms.E052": "EOM 105D",
  "paymentterms.E053": "EOM 60天（截止到20日） 20",
  "paymentterms.E054": "EOM 30天 (截止日期为20日)",
  "paymentterms.E055": "16日之前的30天（截止日期为25日）。",
  "paymentterms.E056": "EOM 85D (截止25日)",
  "paymentterms.E057": "EOM 90D (5日到期)",
  "paymentterms.E058": "EOM 120D",
  "paymentterms.E059": "5日之前，EOM（截止25日）。",
  "paymentterms.E060": "eom 45天，15日",
  "paymentterms.E061": "64天后，从eom",
  "paymentterms.E062": "10日之前的EOM",
  "paymentterms.E063": "在26日之前的EOM",
  "paymentterms.E064": "EOM 31天",
  "paymentterms.E065": "EOM 50天（截止日期为24日",
  "paymentterms.E120": "120天EOM",
  "paymentterms.EA65": "预计65天",
  "paymentterms.EM15": "EOM 15天",
  "paymentterms.EM20": "EOM 20天",
  "paymentterms.EM30": "30天EOM",
  "paymentterms.EM45": "EOM 45天",
  "paymentterms.EM65": "EOM 65天",
  "paymentterms.EM75": "EOM 75天",
  "paymentterms.EQ01": "季度末（20日之前",
  "paymentterms.GR10": "收到货物后10天",
  "paymentterms.GR30": "收到货物后30天",
  "paymentterms.IK00": "5天内 3%的现金折扣",
  "paymentterms.L001": "lc 150天见效",
  "paymentterms.L002": "lc 180天，见票即付",
  "paymentterms.L003": "LC 105 DAYS BL",
  "paymentterms.L004": "LC 120 DAYS BL",
  "paymentterms.L005": "LC 150 DAYS BL",
  "paymentterms.L006": "LC 180 DAYS BL",
  "paymentterms.L007": "LC 15 DAYS BL",
  "paymentterms.L030": "LC 30 DAYS BL",
  "paymentterms.L105": "自爆炸日期起105天",
  "paymentterms.L120": "自爆炸日期起120天",
  "paymentterms.L150": "自爆炸日期起150天",
  "paymentterms.L180": "l 自爆炸日期起180天内",
  "paymentterms.LD01": "下个月的最后一天",
  "paymentterms.LD02": "下个月的最后一天，下个月的最后一天",
  "paymentterms.LD03": "三个月后的最后一天",
  "paymentterms.LVT0": "16天2%，31天净值",
  "paymentterms.M001": "3 MONTH LATER BY 5TH",
  "paymentterms.M002": "3个月后的第5天",
  "paymentterms.MVT0": "10天3%，16天2%，31天净",
  "paymentterms.P001": "60天期限",
  "paymentterms.P002": "90天期限",
  "paymentterms.P003": "从埃塔胡志明港出发15天",
  "paymentterms.P004": "从Eta起60天，26日付款",
  "paymentterms.PBD1": "Del 30天之前的PDC",
  "paymentterms.PBD2": "Del 45天之前的PDC",
  "paymentterms.PBD3": "Del 60天之前的PDC",
  "paymentterms.PBD4": "投资后90天前的PDC",
  "paymentterms.PBD5": "Del 15天前的PDC",
  "paymentterms.PDC1": "自投资日期起30天内的pdc",
  "paymentterms.PDC2": "自投资日期起60天内的PDC",
  "paymentterms.PDC3": "自投资日期起45天内的PDC",
  "paymentterms.PDC4": "发票日期起15天后",
  "paymentterms.PDC5": "自投资日期起90天内的PDC",
  "paymentterms.PUD1": "在投资后的15天内，PDC就会被淘汰。",
  "paymentterms.PUD2": "在投资后的30天内，PDC将被取消。",
  "paymentterms.PUD3": "在投资后的45天内，PDC",
  "paymentterms.PUD4": "投资后60天内，PDC",
  "paymentterms.PUD5": "投资后90天内，PDC",
  "paymentterms.TX07": "库存到达后7天",
  "paymentterms.TX30": "30天申报",
  "paymentterms.TX45": "45天申报",
  "paymentterms.TX60": "60天申报",
  "paymentterms.TX90": "90天申报",
  "paymentterms.WALL": "99%永远",
  "paymentterms.WL01": "12天净值",
  "paymentterms.Z001": "自定义支付条款（测试",
  "paymentterms.ZB00": "立即支付，无需扣款",
  "paymentterms.ZB01": "14天3%，30/2%，45净值",
  "paymentterms.ZB02": "8天5%，14/2%，21个净值",
  "paymentterms.ZB03": "20天2%，30天净值",
  "paymentterms.ZB04": "10天4%，20/2%，30净值",
  "paymentterms.ZB05": "5天2%，10天净值",
  "phone.landline": "固定电话",
  "phone.mobile": "移动电话",
  "product.altsizes.loadmore": "加载更多备选尺寸",
  "product.discount.saveamount": "保存@@AMOUNT@@",
  "product.discount.savingspercentage": "@@PERCENTAGE@@节省",
  "product.documentType.msds": "安全数据表文件",
  "product.documentType.tds": "TDS文件",
  "product.documenterror": "无法检索到文件",
  "product.loadingdocuments": "加载文档",
  "product.nodocuments": "没有可用的文件",
  "product.safetyinformation": "安全信息",
  "product.type.nonvaluated": "未评估的材料",
  "product.type.packaging": "包装",
  "product.type.returnable": "可退回的包装",
  "product.type.sample": "样品",
  "product.type.services": "服务",
  "product.type.tolling": "收费",
  "product.type.tolling-raw-material-nonvaluated": "收费的原材料没有估价",
  "product.type.tradinggoods": "贸易商品",
  "quote.date": "引用日期",
  "quote.decline": "拒绝报价",
  "quote.details": "报价详情",
  "quote.number": "报价编号",
  "quote.requoteproduct": "要求提供产品",
  "quote.validfrom": "有效期自",
  "quote.validto": "有效期至",
  "quote.value": "引用价值",
  "quotestatus.Declined": "谢绝",
  "quotestatus.Expired": "过期",
  "quotestatus.InProgress": "正在进行中",
  "quotestatus.Open": "开放式",
  "quotestatus.Ordered": "已订购",
  "quotestatus.Submitted": "提交的",
  "quotestatus.Upcoming": "即将推出",
  "regex.placeordertermsandconditions": "通过下订单，您接受了我们的@@条款和条件@@。",
  "regex.reviewtermsandconditions": "点击这里查看我们的@@TERMS_AND_CONDITIONS@@。",
  "requestcancellation.request": "布伦塔格客户服务团队，我想申请取消订单，订单号为@@ORDER_NUMBER@@ 和客户号码。@@customer_number@@。请根据需要提供确认或进一步的信息。",
  "requestchanges.message.billToAddress": "- 以前的帐单地址。\n@@location_old@@\n\n- 新的帐单地址。\n@@location_new@@\n",
  "requestchanges.message.cancelproduct": "- 取消该产品。\n\n产品。@@产品_名称@@@产品\n产品ID。@@产品_编号@@ @产品_编号\n",
  "requestchanges.message.comments": "- 评论。\n@@comments_old@@ → @@comments_new@@\n",
  "requestchanges.message.deliverydate": "- 要求的交付日期。\n@@date_old@@ → @@date_new@@\n",
  "requestchanges.message.heading": "布伦塔格客户服务团队，请您为我的订单更改以下信息。\n\n客户号码 @@CUSTOMER_NUMBER@@@\n订单号码 @@PURCHASE_ORDER_NUMBER@@@\n\n---------\n",
  "requestchanges.message.orderline": "- 改变这个产品。\n\n产品。@@产品_名称@@@产品\n产品ID。@@产品编号@@@产品编号\n- 数量。@@quantity_old@@ → @@quantity_new@@\n- 金额。@@amount_old@@ @@amount_uom_old@@ → @@amount_new@ @@amount_uom_new@@@\n",
  "requestchanges.message.shipToAddress": "- 以前的送货地址。\n@@location_old@@\n\n- 新的送货地址。\n@@location_new@@\n",
  "requestquote.request": "Brenntag客户服务团队，请提供以下内容的报价。\n\n客户编号 @@CUSTOMER_NUMBER@@@\n\n产品。@@产品名称@@@ 产品\n\n产品ID。@@产品_编号@@ @产品_编号\n\n要求的数量。@@QUANTITY@@\n\n要求的金额。@@请求的金额@@@\n\n送货地址。\n@@发货地址@@@地址\n\n要求的交付日期。@@要求的交货日期@@@",
  "show_more.less": "显示更少",
  "show_more.more": "显示更多",
  "show_more.results": "显示更多结果",
  "something.wrong": "哎呀!出了点差错。请再试一次",
  "something.wrong.documents": "哎呀!出了点差错",
  "sortinglabel.-currency": "货币(Z-A)",
  "sortinglabel.-customerName": "客户名称(Z-A)",
  "sortinglabel.-dueDate": "最新的到期日",
  "sortinglabel.-grossAmount.amount": "应付金额最高",
  "sortinglabel.-invoiceNumber": "发票号码(Z-A)",
  "sortinglabel.-issueDate": "最新发布的日期",
  "sortinglabel.-lastLoggedInAt": "最后一次登录 最新的 ",
  "sortinglabel.-lastUpdateDate": "最新更新",
  "sortinglabel.-name": "产品名称（Z-A",
  "sortinglabel.-netAmount": "最高净额",
  "sortinglabel.-orderCreationDate": "最新的订购日期",
  "sortinglabel.-packaging.name": "包装类型(Z-A)",
  "sortinglabel.-quoteCreationDate": "报价日期最新的",
  "sortinglabel.-username": "名称(Z-A)",
  "sortinglabel.-usertype": "用户类型（首先是外部）。",
  "sortinglabel.currency": "货币（A-Z",
  "sortinglabel.customerName": "客户名称（A-Z",
  "sortinglabel.dueDate": "最早的到期日",
  "sortinglabel.grossAmount.amount": "应付金额最低",
  "sortinglabel.invoiceNumber": "发票号码（A-Z",
  "sortinglabel.issueDate": "最早发布的日期",
  "sortinglabel.lastLoggedInAt": "最后登录的最古老的 ",
  "sortinglabel.lastUpdateDate": "最新的最古老的",
  "sortinglabel.name": "产品名称（A-Z",
  "sortinglabel.netAmount": "净金额最低",
  "sortinglabel.orderCreationDate": "订购日期最久的",
  "sortinglabel.packaging.name": "包装类型（A-Z",
  "sortinglabel.quoteCreationDate": "报价日期最早的",
  "sortinglabel.relevance": "关联",
  "sortinglabel.username": "名称（A-Z",
  "sortinglabel.usertype": "用户类型（首先是内部）。",
  "storageconditions.01": "一般存储-食品，医药",
  "storageconditions.02": "一般存储",
  "storageconditions.03": "危险储存",
  "storageconditions.04": "冷藏室储存 食品、医药",
  "storageconditions.05": "易燃环境",
  "storageconditions.06": "冷藏室存储",
  "storageconditions.07": "冷藏室存储",
  "storageconditions.08": "氟化氢储存",
  "storageconditions.09": "氨水储存",
  "storageconditions.10": "不符合规定的存储",
  "storageconditions.11": "液体散装储存",
  "storageconditions.12": "生产区",
  "support.email": "support@brenntagconnect.com",
  "support.email.salesgroup.NL01": "orders.au@brenntag-asia.com",
  "support.email.topic": "查询： {customer PO#}/ {quotation #}/ {customer ID}",
  "support.phonenumber": "123 3453 043",
  "temperatureconditions.01": "&gt;25至40ºC",
  "temperatureconditions.02": "&gt;15至25ºC，湿度可控",
  "temperatureconditions.03": "&gt;8至15ºC，湿度可控",
  "temperatureconditions.04": "&gt;0至8ºC，湿度可控",
  "temperatureconditions.05": "&gt;-20至0ºC",
  "temperatureconditions.06": "-20ºC及以下",
  "terms.agree": "是的，我同意",
  "terms.description": "通过访问或使用Brenntag Connect的任何部分，您同意接受这些使用条款的约束。\n\n如果您不同意本协议的所有条款和条件，您就不能访问Brenntag Connect或使用其任何服务。",
  "terms.disagree": "不，退出",
  "timeunit.many.day": "天数",
  "timeunit.many.month": "月",
  "timeunit.many.week": "周数",
  "timeunit.many.year": "岁月",
  "timeunit.one.day": "日子",
  "timeunit.one.month": "月",
  "timeunit.one.week": "周",
  "timeunit.one.year": "年",
  "toast.error.coadocuments": "检索CoA文件时出了问题",
  "toast.error.createuser": "创建用户时出了点差错",
  "toast.error.customernotfound": "出错了。请联系Brenntag Connect。",
  "toast.error.customers": "检索客户时出了问题",
  "toast.error.invoices": "检索发票数据时出了问题",
  "toast.error.languagechange": "语言变更失败",
  "toast.error.orderdetails": "检索订单详情时出了问题",
  "toast.error.orders": "检索订单历史时出了问题",
  "toast.error.placingorder": "下订单时出了问题",
  "toast.error.price": "检索价格时出了问题",
  "toast.error.productdocuments": "检索产品文件时出了问题",
  "toast.error.products": "检索产品数据时出了问题",
  "toast.error.quote": "检索报价详情时出了问题",
  "toast.error.quotereject": "拒绝报价时出了问题",
  "toast.error.quotes": "检索报价时出了问题",
  "toast.error.saveuser": "保存用户更改时出了问题",
  "toast.error.userinfo": "检索用户信息时出了问题",
  "toast.error.userservice": "检索用户数据时出了问题",
  "toast.error.userservice.emailaddressexists": "电子邮件地址为@@EMAIL@@的用户已经存在",
  "toast.error.userservice.permissionsoutsidesalesgroup": "你不能创建或修改分配给你的销售组以外的用户。",
  "toast.error.userservice.savefailed": "保存用户数据时出了问题",
  "toast.error.validatingcart": "验证购物车时出了问题",
  "toast.success.createuser": "用户@@USER@@成功创建",
  "toast.success.deleteuser": "用户@@USER@@成功删除",
  "toast.success.resetpassword": "我们刚刚给你发了一封电子邮件，地址是@@EMAIL@@，以重置你的密码。",
  "toast.success.saveuser": "用户@@USER@@成功保存",
  "user.accessrights": "访问权和语言",
  "user.accessrights.message": "为客户分配访问权限",
  "user.bcaccessstatus": "布伦塔格连接访问状态",
  "user.create": "创建用户",
  "user.createdon": "创建于",
  "user.delete.confirmation": "这是不可能被撤销的，继续？",
  "user.delete.message": "用户@@USER@@将被不可逆转地从系统中删除。",
  "user.edit": "编辑用户",
  "user.information": "用户信息",
  "user.lastpasswordreset": "最后一次密码重置",
  "user.modal.terminate.confirmation": "是否确实要终止此用户？",
  "user.modal.terminate.message": "警告：被终止的用户将无法再登录Brenntag Connect。",
  "user.notes": "笔记",
  "user.notes.placeholder": "例如：关于工作时间的信息，备用联系人",
  "user.role": "角色",
  "user.save": "保存更改",
  "user.search.customer": "搜索客户号码或姓名",
  "user.selectcustomer": "选择客户",
  "user.selectlanguage": "选择语言",
  "user.view": "查看用户",
  "userEdit.cancel.confirm": "你确定要取消吗？",
  "userEdit.cancel.create.external": "取消 \"创建外部用户\"。",
  "userEdit.cancel.create.internal": "取消 \"创建内部用户\"。",
  "userEdit.cancel.edit.external": "取消 \"编辑外部用户\"。",
  "userEdit.cancel.edit.internal": "取消 \"编辑内部用户\"。",
  "userEdit.message.cannotedit": "您无法编辑此用户的用户详细信息。如果您想编辑此用户，请联系 Brenntag。",
  "userrole.Admin": "管理员",
  "userrole.CSR": "企业社会责任",
  "userrole.ReadUser": "只读的用户",
  "userrole.SuperAdmin": "超级管理员",
  "userrole.User": "用户",
  "userrole.UserAdmin": "用户管理员",
  "userrole.UserManager": "用户经理",
  "userrole.description": "用户角色",
  "validationerror.invalid-date": "选定的日期是无效的",
  "validationerror.invalid-moq": "所选金额低于最低订购量",
  "validationerror.not-authorized": "未授权",
  "validationerror.not-found": "该产品不存在",
  "validationerror.price-changed": "该产品的价格已被更新",
  "validationerror.price-mismatch": "部分价格已被更新",
  "validationerror.price-not-found": "没有找到该产品的价格。请通过聊天与我们联系，要求提供价格。",
  "validationerror.uom-mismatch": "该产品的UOM不符合",
  "video.invoices": "发票",
  "video.invoices.description": "了解如何查找和下载发票",
  "video.ordering": "订购和重新订购",
  "video.ordering.description": "了解如何订购和重新订购产品",
  "video.orderlist": "查看订单列表",
  "video.orderlist.description": "了解您的订单清单和订单历史",
  "video.productsearch": "产品搜索",
  "video.productsearch.description": "了解如何搜索产品和查看产品细节"
} as const
